export const getServerStatuses = state => state.syncReducer.serverStatuses
export const getServerStatus = (state, serverId) =>
    getServerStatuses(state)[serverId] || {
        status: 'unknown',
        numPlayers: 0,
    }



// WEBPACK FOOTER //
// ./src/features/Sync/data/serverStatuses/selectors.js